import { NgModule } from '@angular/core'
import { SearchResultsComponent } from './search-results.component'
import { CmsComponentsBaseModule } from '../cms-components-base.module'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { CmsSearchResultItemWrapperComponent } from './cms-search-result-item-wrapper/cms-search-result-item-wrapper.component'
import {
  CmsSearchResultItemFaqComponent
} from './cms-search-result-item-wrapper/cms-search-result-item-faq/cms-search-result-item-faq.component'
import { CmsSearchResultItemComponent } from './cms-search-result-item-wrapper/cms-search-result-item/cms-search-result-item.component'
import { CmsActiveFacetsComponent } from './cms-active-facets/cms-active-facets.component'
import { CmsFacetListComponent } from './cms-facet-list/cms-facet-list.component'
import { CmsFacetComponent } from './cms-facet-list/cms-facet/cms-facet.component'
import { LinkModule } from '../shared/link/link.module'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { RouterModule } from '@angular/router'
import { IconModule } from '@spartacus/storefront'
import { SafeHtmlModule } from '../../pipes/sanitize-html/safe-html.module'
import {
  CmsSearchResultItemJobComponent
} from './cms-search-result-item-wrapper/cms-search-result-item-job/cms-search-result-item-job.component'
import { UrlModule } from '@spartacus/core'
import {
  CmsSearchResultItemVideoComponent
} from './cms-search-result-item-wrapper/cms-search-result-item-video/cms-search-result-item-video.component'

@NgModule({
  declarations: [
    SearchResultsComponent,
    CmsSearchResultItemWrapperComponent,
    CmsSearchResultItemFaqComponent,
    CmsSearchResultItemComponent,
    CmsActiveFacetsComponent,
    CmsFacetListComponent,
    CmsFacetComponent,
    CmsSearchResultItemJobComponent,
    CmsSearchResultItemVideoComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    InfiniteScrollModule,
    LinkModule,
    MbI18nModule,
    RouterModule,
    IconModule,
    SafeHtmlModule,
    UrlModule
  ],
  exports: [
    SearchResultsComponent,
    CmsSearchResultItemWrapperComponent,
    CmsSearchResultItemFaqComponent,
    CmsSearchResultItemComponent,
    CmsActiveFacetsComponent,
    CmsFacetListComponent,
    CmsFacetComponent,
    CmsSearchResultItemJobComponent,
    CmsSearchResultItemVideoComponent
  ]
})
export class SearchResultsModule {}
